module.exports = __webpack_public_path__ + "static/008_001-0b62a54baae1a2ed98e1a42b7f745c26.jpg";